import type {
  MagentoApiUpdatePaymentMethodMutationResponse,
  MagentoApiUpdatePaymentMethodMutationVariables,
} from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const updateOrderPaymentMethodEndpoint = (builder: MagentoApiBuilder) => ({
  updateOrderPaymentMethod: builder.mutation<
    MagentoApiUpdatePaymentMethodMutationResponse,
    MagentoApiUpdatePaymentMethodMutationVariables
  >({
    query: (variables) => ({
      method: "updatePaymentMethod",
      params: [variables],
    }),
    invalidatesTags: [TAGS.ORDER],
  }),
});
